import {
  withUser,
  UserProps,
} from "@customer-tools-web/component-authentication";
import * as React from "react";
import { LoadableComponent } from "react-loadable";
import { withRouter, RouteComponentProps } from "react-router";
import { ROUTE_URL, URL_PREFIX } from "../../common/const";
import { isCanAccessSpecialist } from "./helper";

type Props = UserProps & RouteComponentProps;

export default function (
  ComposedComponent:
    | (React.ComponentClass<any, any> & LoadableComponent)
    | (React.FC<any> & LoadableComponent)
) {
  const getIsSpecialistSlotList = (pathname: string): boolean =>
    pathname === ROUTE_URL.areaCondoSpecialist.slotList;
  const getIsSpecialistSlotEdit = (pathname: string): boolean =>
    pathname?.includes(ROUTE_URL.areaCondoSpecialist.slotEdit) ||
    pathname?.includes(ROUTE_URL.areaCondoSpecialist.slotEditSuccess);
  const getIsSpecialistList = (pathname: string): boolean =>
    pathname === ROUTE_URL.areaCondoSpecialist.default;
  const getIsSpecialistAdd = (pathname: string): boolean =>
    pathname?.includes(ROUTE_URL.areaCondoSpecialist.create) ||
    pathname?.includes(ROUTE_URL.areaCondoSpecialist.createSuccess);

  const getIsSpecialistUpgradeListing = (pathname: string): boolean =>
    pathname?.includes(ROUTE_URL.areaCondoSpecialist.upgradeListing);

  const redirectToNonExistingPage = (props: Props) => {
    props.history?.push(`${URL_PREFIX}/non-existingpage`);
  };

  const checkSpecialistSlotListPermission = (
    props: Props,
    pathname: string
  ) => {
    if (
      getIsSpecialistSlotList(pathname) &&
      !props?.user?.permissions?.specialist?.canViewSlot
    ) {
      redirectToNonExistingPage(props);
    }
  };

  const checkSpecialistSlotEditPermission = (
    props: Props,
    pathname: string
  ) => {
    if (
      getIsSpecialistSlotEdit(pathname) &&
      !props?.user?.permissions?.specialist?.canEditSlot
    ) {
      redirectToNonExistingPage(props);
    }
  };

  const checkSpecialistListPermission = (props: Props, pathname: string) => {
    if (getIsSpecialistList(pathname)) {
      if (!isCanAccessSpecialist(props?.user?.id)) {
        if (
          !props?.user?.permissions?.specialist?.canViewAreaAndCondoSpecialist
        ) {
          redirectToNonExistingPage(props);
        }
      }
    }
  };

  const checkSpecialistAddPermission = (props: Props, pathname: string) => {
    if (getIsSpecialistAdd(pathname)) {
      if (
        !props?.user?.permissions?.specialist?.canEditAreaAndCondoSpecialist
      ) {
        redirectToNonExistingPage(props);
      }
    }
  };

  const checkSpecialistUpgradeListingPermission = (
    props: Props,
    pathname: string
  ) => {
    if (getIsSpecialistUpgradeListing(pathname)) {
      if (
        !isCanAccessSpecialist(props?.user?.id) ||
        !props?.user?.permissions?.specialist?.canEditAreaAndCondoSpecialist
      ) {
        redirectToNonExistingPage(props);
      }
    }
  };

  const PermissionsGuard: React.FC<Props> = (props: Props) => {
    React.useEffect(() => {
      const pathname = props?.location?.pathname;
      checkSpecialistSlotListPermission(props, pathname);
      checkSpecialistSlotEditPermission(props, pathname);
      checkSpecialistListPermission(props, pathname);
      checkSpecialistAddPermission(props, pathname);
      checkSpecialistUpgradeListingPermission(props, pathname);
    }, [props.user?.permissions]);

    return <ComposedComponent {...props} />;
  };

  return withUser(withRouter(PermissionsGuard));
}
